import React, {useContext} from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';
import {labels} from '../../../../util/utils';
import RadioButton from '../../BaseComponentWrappers/MotifRadio';
import {getAnnualizedAmount} from './MeasurementBasisConfig';
import {useSelector, useDispatch} from 'react-redux';
import {getUnresolvedCommentsCount} from '../../../../actions/ValidationControl/validationcontrolactions';
import {DocumentTypeIdContext} from '../../../Main/Forms/CanvasFormContainer';
import {materialityTypes} from '../../../../util/uiconstants';
import {useDocumentId, useEngagementId} from '../../../../util/customHooks';

function MeasurementBasisAnnualizedAmountContainer({
	annualizedAmountTitle,
	className,
	currentMateriality,
	isRadioChecked,
	rationale,
	setIsRadioChecked,
	updateMateriality,
	isDisabled
}) {
	const dispatch = useDispatch();

	const engagementId = useEngagementId();
	const documentId = useDocumentId();
	const documentTypeId = useContext(DocumentTypeIdContext);

	const elapsedPeriodInMonthsLowerThanDefault = () => {
		return currentMateriality?.helixModel?.elapsedPeriods < currentMateriality?.helixModel?.totalPeriods;
	};

	const isCapitalBasedMaterilaityType = () => {
		return (
			(currentMateriality?.materialityTypeID === materialityTypes.Equity ||
				currentMateriality?.materialityTypeID === materialityTypes.Assets ||
				currentMateriality?.materialityTypeID === materialityTypes.CapitalBasedOther) &&
			elapsedPeriodInMonthsLowerThanDefault()
		);
	};

	function onRadioButtonClick(isAnnualizedAmountExpectedToBeReported) {
		if (isCapitalBasedMaterilaityType()) {
			updateMateriality(
				isAnnualizedAmountExpectedToBeReported ? currentMateriality?.helixModel?.basisAmount : null,
				isAnnualizedAmountExpectedToBeReported ? null : rationale,
				isAnnualizedAmountExpectedToBeReported
			).then(() => dispatch(getUnresolvedCommentsCount(engagementId, documentId, documentTypeId)));
		} else {
			updateMateriality(
				isAnnualizedAmountExpectedToBeReported
					? getAnnualizedAmount(
							currentMateriality?.helixModel?.basisAmount,
							currentMateriality?.helixModel?.elapsedPeriods,
							currentMateriality?.helixModel?.totalPeriods
					  )
					: null,
				isAnnualizedAmountExpectedToBeReported ? null : rationale,
				isAnnualizedAmountExpectedToBeReported
			).then(() => dispatch(getUnresolvedCommentsCount(engagementId, documentId, documentTypeId)));
		}
	}

	return (
		<StyledMeasurementBasisAnnualizedAmountContainer className={className}>
			<section className="annualizedamount-title">{annualizedAmountTitle}</section>
			<section className="annualizedamount-selection">
				<RadioButton
					key={1}
					radioName="basis"
					labelValue={labels.yes}
					radioValue="yes"
					isChecked={isRadioChecked === true}
					disabled={isDisabled}
					onChange={(e) => {
						setIsRadioChecked(true);
						onRadioButtonClick(true);
					}}
				/>
				<RadioButton
					key={2}
					radioName="basis"
					labelValue={labels.no}
					radioValue="no"
					isChecked={isRadioChecked === false}
					disabled={isDisabled}
					onChange={(e) => {
						setIsRadioChecked(false);
						onRadioButtonClick(false);
					}}
				/>
			</section>
		</StyledMeasurementBasisAnnualizedAmountContainer>
	);
}

MeasurementBasisAnnualizedAmountContainer.propTypes = {
	annualizedAmountTitle: PropTypes.string,
	className: PropTypes.string,
	currentMateriality: PropTypes.object,
	isRadioChecked: PropTypes.bool,
	isSavingRadioSelection: PropTypes.bool,
	rationale: PropTypes.string,
	setIsRadioChecked: PropTypes.func.isRequired,
	updateMateriality: PropTypes.func.isRequired
};

MeasurementBasisAnnualizedAmountContainer.defaultProps = {
	annualizedAmountTitle: labels.isAnnualizedAmountRepresentative,
	isSavingRadioSelection: false,
	rationale: '',
	className: 'annualizedamount-container'
};

export default MeasurementBasisAnnualizedAmountContainer;

const StyledMeasurementBasisAnnualizedAmountContainer = styled.section`
	position: relative;
	margin-bottom: var(--px-20);
	.annualizedamount-title {
		font-size: var(--px-16);
		font-weight: 300;
		color: var(--neutrals-900);
		line-height: var(--px-24);
		margin-bottom: var(--px-16);
		display: block;
	}
`;
